<div class="tooglenav" *ngFor="let nav of navItems">
    <div class="mainLabel">
      {{nav.name}} <mat-icon>expand_more</mat-icon>
    </div>

    <!-- <div class="mainLabel">
      {{nav.name}} <mat-icon>expand_more</mat-icon>
    </div> 
    
    <ng-container> 
      <div class="sublist">
    <a  routerLinkActive="active-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="'/users/profile'">
      My Profile
    </a>
  </div>
   </ng-container> -->
   

    <ng-container *ngFor="let subnav of nav.items">
      <div class="sublist" *ngIf="isSuperAdmin==true && ['NTA', 'System Prompts'].includes(subnav.name)">
        <a (click)="linkclick(subnav)" [routerLink]="subnav.link"  routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}" >{{subnav.name}}</a>
      </div>
      <div class="sublist" *ngIf="subnav.name!='NTA' && subnav.name!='System Prompts'">
        <a (click)="linkclick(subnav)" [routerLink]="subnav.link"  routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}" >{{subnav.name}}</a>
      </div>
    </ng-container>
</div>
